import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import SETTINGS from "../../globals";
import AppSections from "../../utils/AppSections";
import { useApiClient } from "../../contexts/ApiClientContext";
import PagedData from "../../model/PagedData";
import APIEndPoints from "../../utils/APIEndPoints";
import Loading from "../common/Loading";
import UserRoles from "../../model/enums/UserRole";
import Material from "../../model/Material";
import MaterialsListElement from "./MaterialsListElement";
import MaterialsListAddElement from "./MaterialsListAddElement";
import EmbeddingToolInfo from "../../utils/EmbeddingToolInfo";

/*
  Component to manage the display of the existing SITES list
*/
function MaterialsList() {
  // reference to the AuthManager
  const authManager = useAuth();
  // reference to the navigator
  const navigate = useNavigate();
  // reference to the ApiClient instance
  const apiClient = useApiClient();
  // activities information to be displayed
  const [data, setData] = useState<Material[]>([]);
  // manage data loading animation
  const [loading, setLoading] = useState(true);

  // load record data from the server
  useEffect(() => {
    apiClient
      ?.get<PagedData<Material[]>>({
        url: APIEndPoints.MATERIALS.ALL,
        requiresToken: true,
      })
      .then((response: PagedData<Material[]>) => {
        setData(response.items.reverse());
      })
      .catch(() => {
        navigate(SETTINGS.get_path({ section: AppSections.SIGN_IN }));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [apiClient, navigate]);

  const refreshList = () => {
    setLoading(true);
    apiClient
      ?.get<PagedData<Material[]>>({
        url: APIEndPoints.MATERIALS.ALL,
        requiresToken: true,
      })
      .then((response: PagedData<Material[]>) => {
        setData(response.items.reverse());
        // setShowMore(response.items.length > 4);
      })
      .catch(() => {
        navigate(SETTINGS.get_path({ section: AppSections.SIGN_IN }));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      <h3 className="text-left">Create New Material:</h3>
      <div className="grid grid-cols-3 gap-6">
        <MaterialsListAddElement
          canEdit={true}
          navigable={true}
          onFormAdded={refreshList}
        />
      </div>

      <br></br>
      <br></br>
      <h3 className="text-left">Existing Materials:</h3>
      <br></br>

      <div className="grid grid-cols-3 gap-6">
        {data?.length > 0 &&
          data?.map((item) => {
            const canEdit =
              authManager.getUserRole() === UserRoles.ADMIN &&
              !EmbeddingToolInfo.isChemiTool();
            return (
              <MaterialsListElement
                key={item.id}
                data={item}
                canEdit={canEdit}
                navigable={true}
                onDelete={refreshList}
              />
            );
          })}

        {data?.length === 0 && (
          <div className="col-span-4 text-center text-gray-600">
            No Materials available.
          </div>
        )}
      </div>
    </div>
  );
}

export default MaterialsList;
